export const LOGIN = "/";
export const RESET_LINK = "/reset-link";
export const FORGOT_PASSWORD = "/forgot-password";
export const CHANGE_PASSWORD = "/reset-password";

export const DASHBOARD = "/dashboard";
export const ADMIN_PROFILE = "/admin-profile";

export const MANAGE_INSPECTOR = "/manage-inspector";
export const ADD_INSPECTOR = "/manage-inspector/add-inspector";
export const VIEW_INSPECTOR_DETAILS = "/manage-inspector/view-inspector-details";
export const EDIT_INSPECTOR_DETAILS = "/manage-inspector/view-inspector-details/edit-inspector";

export const MANAGE_PROJECT = "/manage-project";
export const ADD_PROJECT = "/manage-project/add-project";
export const VIEW_MANAGE_PROJECT_DETAILS = "/manage-project/view-project-details";
export const EDIT_MANAGE_PROJECT_DETAILS = "/manage-project/view-project-details/edit-manage-project";
export const ADD_NEW_INSPECTION = "/manage-project/view-project-details/add-inspection";
export const WELDING_GAS_INSPECTION_FORM = "/manage-project/view-project-details/welding-gas-form";
export const WELDING_MACHINE_CALIBRATION = "/manage-project/view-project-details/welding-machine-calibration";
export const WELDING_WPQ_INSPECTION = "/manage-project/view-project-details/welding-wpq-inspection";
export const ISO_WELD_LOG = "/manage-project/view-project-details/iso-weld-log";
export const PROJECT_REPORT = "/manage-project/view-project-details/project-report";
export const NCR_REPORT = "/manage-project/view-project-details/ncr-report";

export const NOTIFICATION = "/notification";

export const DESCRIPTION_MASTER = "/master/description-master"
export const SIZE_MASTER = "/master/size-master";
export const ENDS_MASTER = "/master/ends-master";
export const TYPE_MASTER = "/master/type-master";
export const SURFACE_MASTER = "/master/surface-master";
export const WELDING_MASTER = "/master/welding-master"
export const INSPECTION_LOC_MASTER = "/master/inspection-loc-master";
export const MANUFACTURER_MASTER = "/master/manufacturer-master";
export const ADD_DESCRIPTION_MASTER = "/master/description-master/add-description-master";
export const ADD_SIZE_MASTER = "/master/size-master/add-size-master";
export const ADD_ENDS_MASTER = "/master/ends-master/add-ends-master";
export const ADD_TYPE_MASTER = "/master/type-master/add-type-master";
export const ADD_SURFACE_MASTER = "/master/surface-master/add-surface-master";
export const ADD_WELDING_MASTER = "/master/welding-master/add-welding-master";
export const ADD_INSPECTION_LOC_MASTER = "/master/inspection-loc-master/add-inspection-master";
export const ADD_MANUFACTURER_MASTER = "/master/manufacturer-master/add-manufacturer-master";

export const DATA_VERIFICATION = "/data-verification";
export const GLOBAL_SEARCH = "/global-search"